import React, { useEffect } from "react";
import SEO from "../Components/Seo";
import Header from "../Components/Nav/Header";
import Footer from "../Components/Nav/Footer";
import Contact from "../Components/Main/Contact";
import product1 from "../Assets/Products/p1.png";
import product2 from "../Assets/Products/p2.png";
import product3 from "../Assets/Products/p3.png";
import product4 from "../Assets/Products/p4.png";
import product5 from "../Assets/Products/p5.png";
import product6 from "../Assets/Products/p6.png";
import product7 from "../Assets/Products/p7.png";
import Product from "../Components/Others/Product";

const Products = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <div className="bg-[#FFF]">
      <SEO
        title={""}
        description={""}
        name={"Greengate Pharmaceuticals"}
        type={"article"}
      />
      <Header />

      <div className="w-[90%] mt-10 mb-20 mx-auto">
        <h3 className="font-[600] text-[56px] sm:text-[60px] text-[#000]  sm:leading-[74px] ">
          Our Products
        </h3>
        <h4 className="font-[400] max-w-[90%] sm:max-w-[70%] text-[18px] sm:text-[22px] mb-8 sm:mt-4 sm:mb-16 text-[#000] sm:leading-[26px] ">
          Discover our high-quality products, crafted for your health and
          satisfaction. Each item reflects our commitment to excellence and
          innovation in healthcare.
        </h4>

        <div className="w-full flex flex-wrap gap-x-4 gap-y-6 sm:gap-y-8 ">
          <Product
            image={product1}
            title={"Ciprofusion injection"}
            subTitle={"CIPROFKIXACIN Injection B.P (200/100ml)"}
          />
          <Product
            image={product2}
            title={"Evergyl Metronidazole"}
            subTitle={"(Injection 500/100mg)"}
          />
          <Product
            image={product3}
            title={"Dopamed"}
            subTitle={"(Methyldopa Tablet 250mg)"}
          />
          <Product
            image={product4}
            title={"Atmject"}
            subTitle={"(Artemeter Injection 80mg/1ml)"}
          />
          <Product
            image={product5}
            title={"Vaxquin Injection"}
            subTitle={"(10 x 30ml)"}
          />
          <Product
            image={product6}
            title={"Amodiaquine"}
            subTitle={"(Powder 150mg)"}
          />
          <Product
            image={product7}
            title={"ATM Gentamycin"}
            subTitle={"(I.M/I.V 80MG/2ml)"}
          />
          {/* <Product
            image={product7}
            title={"Lumapil Forte"}
            subTitle={"(Artemeter/Lumefantrine 80/480mg)"}
          /> */}
        </div>
      </div>
      <Contact />
      <Footer />
    </div>
  );
};

export default Products;
